export const CONNECTED_OUTCOMES = new Set([
  'connected',
  'call later',
  'info requested',
  'not interested',
  'wrong person',
  'do not call',
  'booked',
]);

export function isConnectedOutcome(outcome: string | null | undefined): boolean {
  if (!outcome) return false;
  return CONNECTED_OUTCOMES.has(outcome.toLowerCase().trim());
}
